angular.module('tf.controllers')

    .controller('billingController', function ($scope, HttpService, NotificationService, BillingService,
                  $uibModal, $rootScope, Session, $state) {
            $scope.sources = [];
            $scope.invoices = [];
            $scope.upcomingInvoice = {};
            $scope.farmPlanSupportBilling = false;
            if(Session.user && Session.user.id) {
                $scope.farmPlanSupportBilling = !Session.user.getFarm().farm.billing.manual_billing;
            }else{
                Session.whenReady().then(function(){
                    $scope.farmPlanSupportBilling = !Session.user.getFarm().farm.billing.manual_billing;
                });
            }

            function loadSources(){
                BillingService.loadSources().then(function(sources) {
                    $scope.sources = sources;
                });
            }

            if($state.current.name.indexOf('invoices') > -1){
                $scope.activeTab = 1;
            } else {
                $scope.activeTab = 0;
            }

            function loadInvoices() {
                BillingService.loadInvoices().then(function (results) {
                    $scope.invoices = results.invoices;
                    $scope.upcomingInvoice = results.upcomingInvoice;
                });
            }

            loadSources();
            loadInvoices();

            $scope.addPaymentMethod = function(){
                var modalInstance = $uibModal.open({
                    animation : true,
                    templateUrl : 'js/components/addPaymentMethod/add-payment-method.html',
                    controller : 'AddPaymentMethodController',
                    size : 'md',
                    windowTopClass : 'change-password-modal',
                    backdrop : 'static'
                });
                modalInstance.result.then(function(success){
                    if(success){
                        $state.go('app.account.billing.payment-methods', {}, {reload: true});
                    }
                });
            };

            $scope.removeSource = function(source){
                NotificationService.confirm("Delete Payment Method", "Are you sure?", function() {
                    BillingService.removeSource(source).then(function (sources) {
                        $scope.sources = sources;
                    });
                });
            };

            $scope.setAsDefault = function(source){
                NotificationService.confirm("Change Default Payment Method", "Are you sure?", function() {
                    BillingService.setAsDefault(source).then(function (sources) {
                        $scope.sources = sources;
                    });
                });
            };

            var stateChangeEvent = $rootScope.$on('$stateChangeStart', function(event, toState, toParams) {
               if(toState.name === 'app.account.billing.payment-methods'){
                   loadSources();
               }else if(toState.name === 'app.account.billing.invoices'){
                   loadInvoices();
               }
            });

            $scope.planSummery = BillingService.planSummery();


            $scope.$on('$destroy', function() {
                stateChangeEvent();
            });
        });